module.exports = __webpack_public_path__ + "img/graduate-avatar.f9821510.jpg";